import { Suspense } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import * as Sentry from '@sentry/react';
import ExploreTabContent from '~/components/Explore/ExploreTabContent';
import Tab from '~/components/Explore/Tab/Tab';
import { FlexStack } from '~/components/atomic';
import { ExploreSkeleton } from '~/components/common/Skeleton';
import useExploreTabStore from '~/store/useExploreTabStore';

export default function Explore() {
  const { activeTab, setActiveTab } = useExploreTabStore();

  return (
    <>
      <Container>
        <FlexStack spacing={16}>
          <Tab activeTab={activeTab} setActiveTab={setActiveTab} />
          <Suspense fallback={<ExploreSkeleton />}>
            <Sentry.ErrorBoundary fallback={undefined}>
              <ExploreTabContent activeTab={activeTab} />
            </Sentry.ErrorBoundary>
          </Suspense>
        </FlexStack>
      </Container>
    </>
  );
}

const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: relative;
    flex-direction: column;
    width: 100%;
    min-height: 100%;
    padding: ${theme.layout.chat_header_height} ${theme.layout.section_side}
      calc(${theme.layout.chat_navigation_height} + 30px);
  `}
`;
